import {
  LOGIN_CALLBACK_ROUTE,
  LOGOUT_CALLBACK_ROUTE,
  PROXY_LOGOUT_CALLBACK_ROUTE,
} from "@stadium/services/auth0";
import { getOriginLoginParams } from "@stadium/services/auth/utils";
import { BASE_PATH } from "@constants/app-defaults";
import { BYSTADIUM_DASHBOARD_HOSTNAME } from "@stadium/helpers/app-routes";
import { IS_AUTH0_ENABLED } from "@stadium/services/auth0/constants";

const PROXY_CALLBACK_PATH = `${BYSTADIUM_DASHBOARD_HOSTNAME}${PROXY_LOGOUT_CALLBACK_ROUTE}`;

export const logoutCommonParamsWithGenericCallback = (asPath) => {
  const appCallbackLogoutURL =
    window.location.origin + BASE_PATH + LOGOUT_CALLBACK_ROUTE + `?returnTo=${asPath}`;

  const encodedAppCallbackLogoutURL = encodeURIComponent(appCallbackLogoutURL);

  return {
    client_id: null,
    returnTo: IS_AUTH0_ENABLED
      ? `${PROXY_CALLBACK_PATH}?returnTo=${encodedAppCallbackLogoutURL}`
      : appCallbackLogoutURL,
  };
};

export const loginCommonParams = (asPath = "") => ({
  redirectUri: window.location.origin + BASE_PATH + LOGIN_CALLBACK_ROUTE,
  appState: { returnTo: asPath || window.location.href },
  ...getOriginLoginParams(),
});
